module.exports = __webpack_public_path__ + "media/audio17.96806c4e.wav";